// import React , { useState } from 'react';
// import './upload-excel-file-pi.scss'
// import moment from 'moment'
// import * as XLSX from 'xlsx' 
// import imgSrc from './spinner.gif'
// import UploadPIService  from './upload-excel-file-pi-list.service'
// const UploadSupplierList = () => {
//     const [Files, setFiles] = useState([]);
//     const [dataOfFiles, setDataOfFiles] = useState([]);
    

//     const callApi  = (excelData) =>{
//         showLoader()
//         UploadPIService.uploadPIData(excelData).then((res)=>{
//             console.log(res)
//             document.getElementById('excelFile').value = '';

//             showSuccessMessage(); 
//             setFiles([])
//             setDataOfFiles([])
//         }).catch((e)=>{
//             console.log(e)
            
//         })
//     }
//     const  showLoader = () => {
//         document.getElementById('loader').style.display = 'block';
//         document.getElementById('successMessage').style.display = 'none';

//     }
    
//     // Function to hide the loader and show the success message
//     const  showSuccessMessage = () => {
//         document.getElementById('loader').style.display = 'none';
//         document.getElementById('successMessage').style.display = 'block';
//         setTimeout(() => {
//             document.getElementById('successMessage').style.display = 'none';
//         }, 1000);
//     }
//     const inputChange = (e)=>{
//         document.getElementById('upload-file-div').style.borderColor = '#00335b'
        
//         let files = e.target.files;
//         console.log(files[0].type)
        
//         if(files.length > 0 && files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
//             setDataOfFiles(e.target.files[0])
//             for (let i = 0; i < files.length; i++) {
//                 console.log(files[i]);               
//                 const reader = new FileReader();
//                 reader.onload = function(e) {
//             // preview.src = e.target.result;
//             console.log(e)
//             console.log(reader)
//             // console.log(JSON.stringify(reader))


            
//             let createObject = [{data:files[i] ,fileImage: reader.result }]
//             console.log(createObject)
//            setFiles(createObject)
            
//             };

//         reader.readAsArrayBuffer(files[i]);
//             }
//         }else{
//             setDataOfFiles([])
//             document.getElementById('upload-file-div').style.borderColor = 'red'
//             document.getElementById('upload-file-div').style.backgroundColor = '#ff90904a'
//             setTimeout(() => {
                
//                 document.getElementById('upload-file-div').style.borderColor = '#00335b'
//                 document.getElementById('upload-file-div').style.backgroundColor = 'rgba(129, 148, 170, 0.1803921569)'
//             }, 2000);

//         }
        
        
//     }
//     console.log(Files)
//     const formatFileSize = (sizeInBytes) => {
//         if (sizeInBytes < 1024) {
//           return sizeInBytes + ' B';
//         } else if (sizeInBytes < 1024 * 1024) {
//           return (sizeInBytes / 1024).toFixed(2) + ' KB';
//         } else {
//           return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
//         }
//       };
//       const DeleteFile = async (id) => {
//                 if(window.confirm("Are you sure you want to remove file?")){
                    
//                     setFiles([]);
//                     setDataOfFiles([]);
//                     document.getElementById('excelFile').value = '';
//                 }else{
//                     // alert('No');
//                 }
//             }

//     const formSubmit = (e)=>{
//                         e.preventDefault()
//                         console.log('form Submit' , dataOfFiles.size)
//                 if(dataOfFiles != {} && dataOfFiles.size != undefined){
//                         const file = dataOfFiles;
//                         const reader = new FileReader();
                
//                     reader.onload = (event) => {
//                         const data = event.target.result;
//                         const workbook = XLSX.read(data, { type: 'binary' });
                
//                     // Assuming you want to read data from the first sheet
//                         const sheetName = workbook.SheetNames[0];
//                         const worksheet = workbook.Sheets[sheetName];
                
//                     // Parse the worksheet data into an array of objects
//                         const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

//       // Convert the date column to a human-readable format

// for (const row of excelData) {
//   let hasError = false;
//   let errorMessage = "";

//   // Check PINO presence
//   if (!row.PINO) {
//     hasError = true;
//     errorMessage += "Missing PINO. ";
//   }

//   // Validate ValidSoldDate
//   if (row.ValidSoldDate && moment(row.ValidSoldDate, ["M/D/YY", "YYYY-MM-DD"], true).isValid()) {
//     row.ValidSoldDate = moment(row.ValidSoldDate, ["M/D/YY", "YYYY-MM-DD"]).format("DD-MMM-YY").toUpperCase();
//   } else {
//     hasError = true;
//     errorMessage += "Invalid ValidSoldDate. ";
//   }

//   // Validate ValidPaymentCompleteDate
//   if (row.ValidPaymentCompleteDate && moment(row.ValidPaymentCompleteDate, ["M/D/YY", "YYYY-MM-DD"], true).isValid()) {
//     row.ValidPaymentCompleteDate = moment(row.ValidPaymentCompleteDate, ["M/D/YY", "YYYY-MM-DD"]).format("DD-MMM-YY").toUpperCase();
//   } else {
//     hasError = true;
//     errorMessage += "Invalid ValidPaymentCompleteDate.";
//   }

//   // Add error info to row
//   row.hasError = hasError;
//   row.error = hasError ? errorMessage.trim() : "";

//   console.log(row);
// }


//       console.log(excelData);
//       if(Array.isArray(excelData) && excelData.length > 0){

//           callApi(excelData)
//       }else{
//              document.getElementById('excelFile').value = '';
//             setFiles([])
//             setDataOfFiles([])
//             alert('NO RECORDS FOUND IN EXCEL FILE ,TRY AGAIN')
//       }

//     //   setExcelData(excelData);


//                     };
                
//                     reader.readAsBinaryString(file);
//                 }else{
//                     console.log('form submited in else section')
//                 }

//   }

//     return (
//         <>
//         <div className='content-wrapper upload-supplier-wrapper'>
//             <div className="kb-modal-data-title">
//                  <div className="kb-data-title">
//                      <h6 className='upload-excel-heading'> Upload Excel File.</h6>
//                  </div>
//              </div>
//             <form onSubmit={formSubmit}> 
//                 <div className='form-upload-wrapper'>
//                     <div className='upload-file-main-div' id='upload-file-div' >
//                     <input type="file" id='excelFile' name="excelFile" accept=".xlsx, .xls" multiple={false} onChange={inputChange} 
//                     onDragEnter={(e)=>{ document.getElementById('upload-file-div').style.borderColor = '#eee'  }}
//                     onDragLeave={(e)=>{ document.getElementById('upload-file-div').style.borderColor = '#00335b'  }}
                    
//                     />
//                        <span id='excelFile-span'>Drag and drop or <span className="file-link">Choose your files</span></span>
//                     </div>
//                 </div>
//                 <div className="kb-buttons-box">
//                         <button 
//                         type="submit" 
//                         className="btn btn-primary form-submit"
//                         disabled={Files.length > 0 ? false : true}
//                         >Upload</button> 
//                         <img src={imgSrc} id='loader' />
//                         <p id='successMessage'> Upload SuccessFully!</p>
//                         {/* <p id='uploadFileAlert'> Upload SuccessFully!</p> */}
//                 </div>
//             </form>
            
//             {Files.length > 0 ?
//                                         <div className="kb-attach-box">
//                                             <hr />
//                                             {
//                                                 Files.map((data, index) => {
                                                    
//                                                     console.log(data.data.lastModifiedDate)
//                                                     const { name,   lastModifiedDate, size } = data.data;
//                                                     // console.log('filename',filename)
//                                                     console.log(moment(lastModifiedDate).format('DD/MM/YY'))

//                                                     return (
//                                                         <div className="file-atc-box" key={index}>
                                                            
//                                                             {
//                                                                 name.match(/.(xlxs|xls)$/i) ?
//                                                                 <div className="file-image"><i className="far fa-file-alt"></i></div>:
//                                                                     <div className="file-image"><i className="far fa-file-alt"></i></div>
//                                                             }
//                                                             <div className="file-detail">
//                                                                 <h6>{name}</h6>
//                                                                 <p><span>Size : {formatFileSize(size)}</span><span className="ml-3">Modified Date : {moment(lastModifiedDate).format('DD/MM/YY')}</span></p>
//                                                                 <div className="file-actions">
//                                                                     <button className="file-action-btn" 
//                                                                     onClick={() => DeleteFile()}
//                                                                     >Delete</button>
                                                                    
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     )
//                                                 })
//                                             }
//                                         </div>
//                                         : <></>}      
// </div>                                        </>
//     );
// }

// export default UploadSupplierList;

import React, { useState } from "react";
import "./upload-excel-file-pi.scss";
import moment from "moment";
import * as XLSX from "xlsx";
import imgSrc from "./spinner.gif";
import UploadPIService from "./upload-excel-file-pi-list.service";

const UploadSupplierList = () => {
  const [Files, setFiles] = useState([]);
  const [dataOfFiles, setDataOfFiles] = useState([]);
  const [uploadResults, setUploadResults] = useState([]);

  const callApi = (excelData) => {
    showLoader();
    setUploadResults([]);
    UploadPIService.uploadPIData(excelData)
      .then((res) => {
        console.log(res);
        document.getElementById("excelFile").value = "";
        const results = Array.isArray(res.data) ? res.data : [];
        setUploadResults(results);
        const allSucceeded = results.every((r) => r.status === "success");
        document.getElementById("loader").style.display = "none";
        if (allSucceeded) {
          showSuccessMessage();
        }
        setFiles([]);
        setDataOfFiles([]);
      })
      .catch((e) => {
        console.log(e);
        document.getElementById("loader").style.display = "none";
      });
  };

  const showLoader = () => {
    document.getElementById("loader").style.display = "block";
    document.getElementById("successMessage").style.display = "none";
  };

  const showSuccessMessage = () => {
    document.getElementById("loader").style.display = "none";
    document.getElementById("successMessage").style.display = "block";
    setTimeout(() => {
      document.getElementById("successMessage").style.display = "none";
    }, 1000);
  };

  // ✅ Handles both input change and drag-drop
  const handleFile = (file) => {
    if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setDataOfFiles(file);
      const reader = new FileReader();
      reader.onload = function () {
        const createObject = [{ data: file }];
        setFiles(createObject);
      };
      reader.readAsArrayBuffer(file);
      document.getElementById("upload-file-div").style.borderColor = "#00335b";
      document.getElementById("upload-file-div").style.backgroundColor =
        "rgba(129, 148, 170, 0.1803921569)";
    } else {
      setDataOfFiles([]);
      document.getElementById("upload-file-div").style.borderColor = "red";
      document.getElementById("upload-file-div").style.backgroundColor =
        "#ff90904a";
      setTimeout(() => {
        document.getElementById("upload-file-div").style.borderColor = "#00335b";
        document.getElementById("upload-file-div").style.backgroundColor =
          "rgba(129, 148, 170, 0.1803921569)";
      }, 2000);
    }
  };

  // 🟩 File Input Change
  const inputChange = (e) => {
    if (e.target.files.length > 0) handleFile(e.target.files[0]);
  };

  // 🟩 Drag Events
  const handleDragOver = (e) => {
    e.preventDefault();
    document.getElementById("upload-file-div").style.borderColor = "#4c6fff";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    document.getElementById("upload-file-div").style.borderColor = "#00335b";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    document.getElementById("upload-file-div").style.borderColor = "#00335b";
    if (e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes < 1024) return sizeInBytes + " B";
    if (sizeInBytes < 1024 * 1024)
      return (sizeInBytes / 1024).toFixed(2) + " KB";
    return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const DeleteFile = () => {
    if (window.confirm("Are you sure you want to remove file?")) {
      setFiles([]);
      setDataOfFiles([]);
      document.getElementById("excelFile").value = "";
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();
    if (dataOfFiles && dataOfFiles.size !== undefined) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        for (const row of excelData) {
          let hasError = false;
          let errorMessage = "";

          if (!row.PINO) {
            hasError = true;
            errorMessage += "Missing PINO. ";
          }

          if (
            row.ValidSoldDate &&
            moment(row.ValidSoldDate, ["M/D/YY", "DD-MM-YY", "YYYY-MM-DD"], true).isValid()
          ) {
            row.ValidSoldDate = moment(row.ValidSoldDate, [
              "M/D/YY",
              "DD-MM-YY",
              "YYYY-MM-DD",
            ])
              .format("DD-MMM-YY")
              .toUpperCase();
          } else {
            hasError = true;
            errorMessage += "Invalid ValidSoldDate. ";
          }

          if (
            row.ValidPaymentCompleteDate &&
            moment(row.ValidPaymentCompleteDate, ["M/D/YY", "DD-MM-YY", "YYYY-MM-DD"], true)
              .isValid()
          ) {
            row.ValidPaymentCompleteDate = moment(
              row.ValidPaymentCompleteDate,
              ["M/D/YY", "DD-MM-YY", "YYYY-MM-DD"]
            )
              .format("DD-MMM-YY")
              .toUpperCase();
          } else {
            hasError = true;
            errorMessage += "Invalid ValidPaymentCompleteDate.";
          }

          row.hasError = hasError;
          row.error = hasError ? errorMessage.trim() : "";
        }

        if (excelData.length > 0) callApi(excelData);
        else {
          document.getElementById("excelFile").value = "";
          setFiles([]);
          setDataOfFiles([]);
          alert("NO RECORDS FOUND IN EXCEL FILE, TRY AGAIN");
        }
      };

      reader.readAsBinaryString(dataOfFiles);
    }
  };

  return (
    <div className="content-wrapper upload-container-2">
      <div className="upload-box-2">
        <h2 className="upload-heading-2">Import Excel File</h2>
        <form onSubmit={formSubmit}>
          <div
            className="upload-drop-area-2"
            id="upload-file-div"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              id="excelFile"
              name="excelFile"
              accept=".xlsx, .xls"
              onChange={inputChange}
            />
            <span id="excelFile-span">
              Drag and drop or <span className="file-link">choose your file</span>
            </span>
          </div>

          <div className="upload-actions-2">
            <button
              type="submit"
              className="btn-2 btn-primary"
              disabled={Files.length === 0}
            >
              Upload Excel File
            </button>
            <img src={imgSrc} id="loader" style={{ display: "none" }} alt="" />
            <p id="successMessage" style={{ display: "none" }}>
              Upload Successfully!
            </p>
          </div>
        </form>

        {Files.length > 0 && (
          <div className="file-info-2">
            <hr />
            {Files.map((data, index) => {
              const { name, lastModifiedDate, size } = data.data;
              return (
                <div className="file-card-2" key={index}>
                  <div className="file-icon">📄</div>
                  <div className="file-details">
                    <h6>{name}</h6>
                    <p>
                      Size: {formatFileSize(size)} | Modified:{" "}
                      {moment(lastModifiedDate).format("DD/MM/YY")}
                    </p>
                    <button className="file-delete-btn-2" onClick={DeleteFile}>
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {uploadResults.length > 0 && (
          <div className="upload-results-2">
            <hr />
            <table className="upload-results-table-2">
              <thead>
                <tr>
                  <th>PINO</th>
                  <th>Status</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {uploadResults.map((result, index) => (
                  <tr
                    key={index}
                    className={
                      result.status === "success"
                        ? "upload-result-success"
                        : "upload-result-error"
                    }
                  >
                    <td>{result.PINO}</td>
                    <td>{result.status}</td>
                    <td>{result.message || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadSupplierList;
